import LinkifiedText from './LinkifiedText';

export { LinkifiedText };
